import {
  Button,
  Layout,
  notification,
  Skeleton,
  theme,
  Typography,
} from "antd";
import React, { useContext, useRef, useState } from "react";
import {
  initUserSlice,
  setPropertiesUser,
  updateUser,
} from "../Slices/user.slice";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import { Dropdown } from "antd";
import routes from "../../../engine/routes";
import {
  diplomas,
  languagesList,
  levels,
  listRoles,
  modeInterpretariat,
  roles,
  subRoles,
} from "../../../utils/constants";
import {
  ActionRoleSpecific,
  onlyRoleMapping,
  userHasLevel,
} from "../../../engine/AuthRoute";
import { countryList } from "../../../utils/listsLabels";
import { UserContext } from "../../../engine/context/User.context";
import dayjs from "../../../utils/dayjs";
import { http } from "../../../engine/api/http";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import { ActionDropdown } from "../../../shared/components/ActionDropdown/ActionDropdown";
import { HiOutlineMail } from "react-icons/hi";
import { t } from "i18next";
import {
  confirmDeleteUserInstitution,
  confirmFinalUserDelete,
} from "../../../shared/components/Modals/modals";
import { deleteUser } from "../../Institutions/Slices/InstitutionUser.slice";
import { doesThisEmailExist } from "../../../engine/api/apiRequest";

const { Content, Sider, Header, Footer } = Layout;

export function UserDetail({ unitId, expanded, onClose }) {
  const { id } = useParams();
  const { user, loading } = useSelector(state => state.userControl);

  const { init, clear } = initUserSlice({ id });

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const [ready, setReady] = useState(false);

  const navigate = useNavigate();

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const {
    info: { firstname, lastname, genre, phone },
    status,
    comment,
    email,
    subRoles,
    role,
  } = user;


  const inputs = [
    {
      parentLabel: "",
      children: [
        {
          label: t("userDetail.lastname"),
          name: "info.lastname",
          value: lastname,
          type: "input",
          required: true,
          col: 24,
        },
        {
          label: t("userDetail.firstname"),
          name: "info.firstname",
          value: firstname,
          required: true,
          type: "input",
          col: 24,
        },
        {
          label: t("userDetail.email"),
          name: "email",
          required: true,
          normalize: value => value && value.toLowerCase(),
          value: email,
          type: "email",
          col: 24,
        },
        {
          label: t("userDetail.telephone"),
          name: "phone",
          value: phone,
          type: "input",
          col: 24,
        },
        {
          label: t("userDetail.remark"),
          name: "comment",
          value: comment,
          type: "textarea",
          col: 24,
        },
      ],
    },
    {
      parentLabel: userHasLevel({
        not: {
          [roles.user]: "r", //
        },
      })
        ? t("userDetail.actions")
        : "",
      children: [
        {
          label: t("userDetail.roles"),
          name: "role",
          value: role,
          disabled: !onlyRoleMapping([roles.superAdmin]),
          required: true,
          type: "select",
          selectContent: listRoles(),
          col: 24,
        },
        {
          label: t("userDetail.accesAutorized"),
          name: "status",
          value: status,
          required: true,
          disabled: !onlyRoleMapping([roles.superAdmin]),
          visible: userHasLevel({
            not: {
              [roles.user]: "r", //
            },
          }),
          type: "select",
          selectContent: [
            { label: t("active"), value: "active" },
            { label: t("inactive"), value: "inactive" },
            { label: t("archived"), value: "archived" },
          ],
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label: id === "new" ? t("routes.userNewUser") : t("userDetail.save"),
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];

  const onSubmitForm = async data => {
    if (id === "new") {
      //data.role = roles.user;
    }

    let exist = id === "new" ? await doesThisEmailExist(data.email) : false;

    if (exist) {
      return notification.error({
        message: t("institutionUser.emailAlreadyExists"),
        duration: 5000,
      });
    }

    await dispatch(setPropertiesUser(data));
    dispatch(updateUser());
  };

  const sendEmail = async () => {
    let caller = await http.post("/notifications/invitation", { userId: id });
    caller.status === 200 &&
      notification.success({
        message: t("userDetail.emailSentWithSuccess"),
      });
  };

  const deleteUserInstitution = async () => {
    const res = await http.get("/users/" + user._id + "/deleteStatus");

    confirmDeleteUserInstitution({
      onOk: async () => {
        confirmFinalUserDelete({
          onOk: async () => {
            await dispatch(deleteUser(user._id));
            notification.success({
              message: `Utilisateur supprimé`,
            });

            navigate(routes.users().list.path);
          },
          user: user,
        });
      },
      props: res.data,
    });
  };

  return (
    <>
      <Typography.Title level={3} className={""}>
        {routes.users(id).detail.title}
      </Typography.Title>
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <ActionDropdown
            rule={{
              only: {
                [roles.admin]: "crud",
                [roles.permanance]: "crud",
              },
            }}
          >
            <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
              <a onClick={sendEmail}>{t("institutionUser.sendInvitationEmail")}</a>
            </ActionRoleSpecific>
            <ActionRoleSpecific only={[roles.superAdmin]}>
              <a onClick={deleteUserInstitution}>
                Supprimer le compte (Super admin)
              </a>
            </ActionRoleSpecific>
          </ActionDropdown>

          <CustomForm
            disabled={!onlyRoleMapping([roles.superAdmin])}
            initialValues={user}
            dataSource={inputs}
            handleSubmit={data => onSubmitForm(data)}
            labelCol={24}
            refForm={formRef}
            wrapperCol={24}
            onValuesChange={undefined}
          />
        </>
      )}
    </>
  );
}
